module.exports = __webpack_public_path__ + "img/prize-03.edbdd8e6.png";